module.exports = __webpack_public_path__ + "img/clients-say-logo_1.c0f3ba50.png";